import { render } from "./SeRegion.vue?vue&type=template&id=2c1cb551"
const script = {}

import exportComponent from "Z:\\Backups\\Backup Site tecmar\\07.10.2026\\tecmar-transportes-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__